import http from "./http";
import { headers } from "../utils/httpServices";

class HttpService {
  getAll(apiEndpoint) {
    const controller = new AbortController();
    const signal = controller.signal;
    const request = http.get(`${apiEndpoint}`, { signal });
    const cancel = () => controller.abort();

    return { request, cancel };
  }

  getOne(apiEndpoint){
    return http.get(`${apiEndpoint}`);
  }

  create(apiEndpoint, entity) {
    return http.post(`${apiEndpoint}`, entity, { headers });
  }

  update(apiEndpoint, entity) {
    return http.patch(`${apiEndpoint}`, entity, { headers });
  }

  delete(apiEndpoint, entityId) {
    return http.delete(`${apiEndpoint}/${entityId}`, { headers });
  }
}

const httpServices = new HttpService();

export default httpServices;
